module.exports = __webpack_public_path__ + "img/icon_map_jyz_c.4d0918eb.png";